var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mx-page',{key:_vm.timespan,attrs:{"type":"Detail","config":_vm.detail,"parent":_vm.parent,"is-child":_vm.isChild,"master":_vm.master}})
}
var staticRenderFns = []

export { render, staticRenderFns }